/**
 * Returns a new object with only the specified keys from the original object.
 *
 * Equivalent to Elixir's Map.take/2
 */
export function take<T extends object, K extends keyof T>(object: T, keys: K[]): Pick<T, K> {
  return keys.reduce(
    (acc, key) => {
      acc[key] = object[key]
      return acc
    },
    {} as Pick<T, K>
  )
}

/**
 * Returns a new object with the specified keys removed from the original object.
 *
 * Equivalent to Elixir's Map.drop/2
 */
export function drop<T extends object, K extends keyof T>(object: T, keys: K[]): Omit<T, K> {
  return Object.keys(object).reduce(
    (acc, key) => {
      if (!keys.includes(key as K)) {
        acc[key] = object[key]
      }
      return acc
    },
    {} as Omit<T, K>
  )
}

export function isEqual(a: any, b: any): boolean {
  return JSON.stringify(a) === JSON.stringify(b)
}
